(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-title-pdp2026q2"] && !Shopify.designMode) return;
  try {
    if (!window.__pdp2026q2FounderVideoBound) {
    window.__pdp2026q2FounderVideoBound = true;

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-pdp2026q2-founder-open]');
      if (openBtn) {
        var dialogId = openBtn.getAttribute('aria-controls');
        var dialog = dialogId ? document.getElementById(dialogId) : null;
        if (dialog && typeof dialog.showModal === 'function') {
          var iframe = dialog.querySelector('iframe[data-pdp2026q2-founder-src]');
          if (iframe) {
            var src = iframe.getAttribute('data-pdp2026q2-founder-src');
            iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
          }
          dialog.showModal();
          var video = dialog.querySelector('video');
          if (video) {
            video.currentTime = 0;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          }
        }
        return;
      }

      if (event.target.closest('[data-pdp2026q2-founder-close]')) {
        var openDialog = event.target.closest('dialog');
        if (openDialog && typeof openDialog.close === 'function') {
          openDialog.close();
        }
        return;
      }

      if (event.target.classList && event.target.classList.contains('pdp2026q2-founder-modal')) {
        event.target.close();
      }
    });

    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (!dialog || !dialog.classList || !dialog.classList.contains('pdp2026q2-founder-modal')) return;
      var iframe = dialog.querySelector('iframe[data-pdp2026q2-founder-src]');
      if (iframe) iframe.removeAttribute('src');
      var video = dialog.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
